/**
 * Created by apolon on 28.2.2017.
 */

export const cmsURL = "https://cms.why.si/";

export const baseSEO = {
    "url": "http://why.si/",
    "name": "Why.si",
    "author": "Emporij d.o.o.",
    "description": 'Why.si - lifestyle blog, kjer najdete različne foto in video reportaže, intervijuje, izpostavitve in druge zanimivosti. Vsekakor ne bo manjkalo tudi Jameson zgodb in novic.',
    "keywords": "why.si, taste, tastethatswhy, Jameson, Pernod Ricard Slovenija, Sine Metu, sinemetu, lifestyle blog, blog, bloger",
    "image": '/images/why.png'
};



// WEBPACK FOOTER //
// ./src/config.js